"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlayersOfFaction = exports.getAllPlayers = exports.getPlayer = exports.enlistToFaction = exports.getPlayerFactionPDA = exports.getIDL = exports.FactionType = void 0;
const anchor_1 = require("@project-serum/anchor");
const baseIdl = {
    version: '0.0.0',
    name: 'enlist_to_faction',
    instructions: [
        {
            name: 'processEnlistPlayer',
            accounts: [
                {
                    name: 'playerFactionAccount',
                    isMut: true,
                    isSigner: false,
                },
                {
                    name: 'playerAccount',
                    isMut: false,
                    isSigner: true,
                },
                {
                    name: 'systemProgram',
                    isMut: false,
                    isSigner: false,
                },
                {
                    name: 'clock',
                    isMut: false,
                    isSigner: false,
                },
            ],
            args: [
                {
                    name: 'bump',
                    type: 'u8',
                },
                {
                    name: 'factionId',
                    type: 'u8',
                },
            ],
        },
    ],
    accounts: [
        {
            name: 'PlayerFactionData',
            type: {
                kind: 'struct',
                fields: [
                    {
                        name: 'owner',
                        type: 'publicKey',
                    },
                    {
                        name: 'enlistedAtTimestamp',
                        type: 'i64',
                    },
                    {
                        name: 'factionId',
                        type: 'u8',
                    },
                    {
                        name: 'bump',
                        type: 'u8',
                    },
                    {
                        name: 'padding',
                        type: {
                            array: ['u64', 5],
                        },
                    },
                ],
            },
        },
    ],
    errors: [
        {
            code: 300,
            name: 'FactionTypeError',
            msg: 'Faction ID must be 0, 1, or 2.',
        },
    ],
    metadata: {},
};
const FACTION_PREFIX = 'FACTION_ENLISTMENT';
var FactionType;
(function (FactionType) {
    FactionType[FactionType["Unenlisted"] = -1] = "Unenlisted";
    FactionType[FactionType["MUD"] = 0] = "MUD";
    FactionType[FactionType["ONI"] = 1] = "ONI";
    FactionType[FactionType["Ustur"] = 2] = "Ustur";
})(FactionType = exports.FactionType || (exports.FactionType = {}));
function getIDL(programId) {
    const _tmp = baseIdl;
    _tmp['metadata']['address'] = programId.toBase58();
    return _tmp;
}
exports.getIDL = getIDL;
function getPlayerFactionPDA(playerPublicKey, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        return anchor_1.web3.PublicKey.findProgramAddress([Buffer.from(FACTION_PREFIX, 'utf8'), playerPublicKey.toBuffer()], programId);
    });
}
exports.getPlayerFactionPDA = getPlayerFactionPDA;
/**
 *  Create transaction instruction which can be used to enlist a player to a faction.
 */
function enlistToFaction(connection, factionID, playerPublicKey, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const [playerFactionPda, bump] = yield getPlayerFactionPDA(playerPublicKey, programId);
        const idl = getIDL(programId);
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const program = new anchor_1.Program(idl, programId, provider);
        const txInstruction = yield program.instruction.processEnlistPlayer(bump, factionID, {
            accounts: {
                playerFactionAccount: playerFactionPda,
                playerAccount: playerPublicKey,
                systemProgram: anchor_1.web3.SystemProgram.programId,
                clock: anchor_1.web3.SYSVAR_CLOCK_PUBKEY,
            },
        });
        return txInstruction;
    });
}
exports.enlistToFaction = enlistToFaction;
/**
 * Get a player's faction information
 */
function getPlayer(connection, playerPublicKey, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        // Wallet not required to query player faction account
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const idl = getIDL(programId);
        const program = new anchor_1.Program(idl, programId, provider);
        const [playerFactionPDA] = yield getPlayerFactionPDA(playerPublicKey, programId);
        const obj = yield program.account.playerFactionData.fetch(playerFactionPDA);
        return obj;
    });
}
exports.getPlayer = getPlayer;
/**
 * Get all players
 */
function getAllPlayers(connection, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        // Wallet not required to query player faction accounts
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const idl = getIDL(programId);
        const program = new anchor_1.Program(idl, programId, provider);
        const programAccounts = yield program.account.playerFactionData.all();
        const players = programAccounts.map((player) => player.account);
        return players;
    });
}
exports.getAllPlayers = getAllPlayers;
/**
 * Get all players of a specified faction
 */
function getPlayersOfFaction(connection, factionID, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        // Wallet not required to query player faction accounts
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const idl = getIDL(programId);
        const program = new anchor_1.Program(idl, programId, provider);
        const programAccounts = yield program.account.playerFactionData.all();
        const filtered = programAccounts
            .map((player) => player.account)
            .filter((player) => player.factionId == factionID);
        return filtered;
    });
}
exports.getPlayersOfFaction = getPlayersOfFaction;
//# sourceMappingURL=factions.js.map